// errorReporter.js — Lightweight production error tracking
// Logs unhandled errors to Supabase ns_errors table (no Sentry needed)
import { supabase } from '../supabase';

let _userEmail = null;
export function setErrorUser(email) { _userEmail = email; }

function report(message, source, extra = {}) {
  if (window.location.hostname === 'localhost') return;
  const key = 'ns_err_count';
  const count = parseInt(sessionStorage.getItem(key) || '0', 10);
  if (count >= 5) return;
  sessionStorage.setItem(key, String(count + 1));

  // Use the existing supabase client — no duplicate keys
  supabase.from('ns_errors').insert({
    message: String(message).slice(0, 500),
    source: String(source).slice(0, 200),
    user_email: _userEmail,
    url: window.location.href,
    user_agent: navigator.userAgent.slice(0, 200),
    occurred_at: new Date().toISOString(),
    extra: JSON.stringify(extra).slice(0, 500),
  }).then(() => {}).catch(() => {}); // never throw from error reporter
}

export function initErrorReporter() {
  // Global JS errors
  window.addEventListener('error', (e) => {
    report(e.message, e.filename + ':' + e.lineno, { stack: e.error?.stack?.slice(0, 300) });
  });

  // Unhandled promise rejections
  window.addEventListener('unhandledrejection', (e) => {
    report(
      e.reason?.message || String(e.reason),
      'unhandledrejection',
      { stack: e.reason?.stack?.slice(0, 300) }
    );
  });
}
